import React, { useEffect, useCallback } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Configuration from "../../configuration";
import entete3 from "../../assets/img/logoindustrie3.png";
import entete2 from "../../assets/img/logoindustrie2.png";

import { useDispatch } from "react-redux";
import { getDetailEntete, getDetailLigneEntete } from "../../Redux/reclamationReduce";

const ImprimerReclamation = ({ t, idReclamation, type, client }) => {

  const dispatch = useDispatch();
  /* detailReclamation */




  const generatePDF = async () => {
    try {
      console.log("ici");

      // Récupérer les données via dispatch (tes appels API)
      const det = await dispatch(getDetailLigneEntete({ idReclamation }));
      const data = det.payload;

      const dataReclamation = await dispatch(getDetailEntete({ idReclamation }));
      const reclamation = dataReclamation.payload;

      let currentY = 20;

      const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
      });

      // Logo
      const enteteImg = client === Configuration.industrie3 ? entete3 : entete2;
      doc.addImage(enteteImg, "PNG", 15, 5, 30, 20);

      // Numéro commande / réclamation
      doc.setFont("helvetica", "bold").setFontSize(12).setTextColor(0, 0, 0);
      doc.text(reclamation.type_reclamation === 2 ? "Numéro Réclamation" : "Numéro Retour", 120, 15);
      doc.setFontSize(9).text(`${reclamation.numero || ""}`, 120, 20);

      // Détails client
      doc.setFont("helvetica", "bold").setFontSize(10);
      doc.text(`Code Client: ${reclamation.grossistes?.Code_client || ""}`, 10, 40);
      doc.text(`Client: ${reclamation.grossistes?.Raison_sociale || ""}`, 10, 45);
      doc.text(
        `${reclamation.type_reclamation === 2 ? "Date Réclamation" : "Date Retour"} ${reclamation.createdAt ? new Date(reclamation.createdAt).toISOString().slice(0, 10) : ""}`,
        10,
        50
      );
      // Status calculé
      const statusText =
        reclamation.etat === 0 && reclamation.type_reclamation === 2
          ? reclamation.status_reclamations?.nom || ""
          : reclamation.etat === 1 && reclamation.type_reclamation === 2
            ? "Cloturée"
            : reclamation.traiter === 0 && reclamation.type_reclamation === 1
              ? ("En cours de traitement par AFC")
              : reclamation.traiter === 1 && reclamation.type_reclamation === 1
                ?(reclamation.motif == 1 ?  "En cours de traitement par CG" : "Traité par AFC")
                : reclamation.traiter === 2 && reclamation.type_reclamation === 1
                  ? "Traitée"
                  : reclamation.traiter === -2 && reclamation.type_reclamation === 1
                    ? "Refusé par CG"
                    : "Refusé par AFC";

      doc.text(
        `${t("status")}: ${statusText} ${reclamation.etat === 2 ? reclamation.date_livraison_afc : reclamation.date_livraison || ""}`,
        10,
        55
      );

      doc.text(reclamation.qualipro != null ? `Référence Qualipro: ${reclamation.qualipro || ""}` : "", 10, 60);
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 65, 200, 65);

      currentY = 70;

      // Colonnes
      let columns = [
        "Code Article",
        t("article"),
        t("qte_reclame"),
        "Quantité Lot",
        t("Reclamation.numero_lot"),
        t("reference_bl"),
        "Date Expiration",
        t("date_liv"),
      ];

      // Ajouter conditionnellement la colonne
      if (data[Object.keys(data)[0]].entete.id_type != null) {
        columns.push(t("Reclamation.type_claim"));
      }

      columns = columns.concat([
        t("Motif"),
        t("commentaire"),
      ]);

      if (reclamation.type_reclamation === 2) {
        columns = [
          t("Motif"),
          `Date ${t("reclamation")}`,
          "Description de la réclamation",
        ];
      }

      // Corps du tableau
      const body = [];

      Object.keys(data).forEach((key) => {
        const entete = data[key].entete;
        const lignes = data[key].ligne;
        const motifSpecial = entete.motif === 1 || entete.motif === 3;

        if (motifSpecial) {
          lignes.forEach((ligne) => {
            if (entete.id_type != null) {
              body.push([
                entete.produits?.Code_article || "",
                entete.produits?.Designation_1 || "",
                ligne.quantite || "",
                ligne.quantite_livraison || "",
                entete.lot || "",
                ligne.numero_livraison || "",
                ligne.date_expiration || "",
                ligne.Date_expedition || "",
                entete.types?.nom || "",
                entete.motif_description || "",
                entete.commentaire || "",
              ]);
            } else {
              body.push([
                entete.produits?.Code_article || "",
                entete.produits?.Designation_1 || "",
                ligne.quantite || "",
                ligne.quantite_livraison || "",
                entete.lot || "",
                ligne.numero_livraison || "",
                ligne.date_expiration || "",
                ligne.Date_expedition || "",
                entete.motif_description || "",
                entete.commentaire || "",
              ]);
            }
          });
        } else {
          body.push([
            entete.motif_description || "",
            entete.createdAt ? new Date(entete.createdAt).toISOString().slice(0, 10) : "",
            entete.commentaire || "",
          ]);
        }
      });

      doc.autoTable({
        startY: currentY,
        head: [columns],
        body: body,
        headStyles: {
          fillColor: false,
          textColor: 0,
          fontSize: 7,
          halign: 'left',
        },
        bodyStyles: {
          fontSize: 7,
        },
        styles: {
          lineWidth: 0, // Pas de bordures par défaut
        },
        didDrawCell: function (data) {
          const doc = data.doc;
          const cell = data.cell;

          // Bordure droite de chaque cellule
          if (cell.section === 'body' || cell.section === 'head') {
            doc.setDrawColor(0);
            doc.setLineWidth(0.1);
            doc.line(
              cell.x + cell.width,
              cell.y,
              cell.x + cell.width,
              cell.y + cell.height
            );
          }

          // Bordure en haut de l'en-tête
          if (data.section === 'head') {
            doc.setDrawColor(0);
            doc.setLineWidth(0.1);
            doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
          }

          // Bordure gauche du tableau (1ère colonne)
          if (data.column.index === 0) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.1);
            doc.line(cell.x, cell.y, cell.x, cell.y + cell.height);
          }

          // Bordure en bas du tableau (ligne horizontale complète sous tout le tableau)
          if (
            data.section === 'body' &&
            data.row.index === data.table.body.length - 1 && // dernière ligne
            data.column.index === 0 // juste une fois, à la 1ère colonne pour commencer la ligne
          ) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.1);

            // largeur totale du tableau = somme des colonnes
            const tableWidth = data.table.columns.reduce((acc, col) => acc + col.width, 0);

            doc.line(
              cell.x,                   // début de la ligne (bord gauche du tableau)
              cell.y + cell.height,     // position y en bas de la dernière cellule
              cell.x + tableWidth,      // fin de la ligne (bord droit du tableau)
              cell.y + cell.height
            );
          }
        },
      });


      doc.save(`reclamation-${reclamation.numero}.pdf`);
    } catch (error) {
      console.error("Erreur lors de la génération du PDF :", error);
      alert("Une erreur est survenue lors de la génération du PDF. Consultez la console pour plus d'infos.");
    }
  };






  return (
    <button type="button" onClick={generatePDF} className={type == 2 ? "btn btn-pdf float-right" : "btn btn-pdf"}>
      {type == 2 ? t("telecharger_pdf") : <i class="fa-solid fa-file-pdf"></i>}
    </button>
  );
};

export default ImprimerReclamation;
